module.exports = __webpack_public_path__ + "img/hero_sp.20076434.jpg";